import api from '@/plugins/axios';
import { GoogleClaimReview } from '@/types';

export const FindFactcheckGoogle = async (query: string, language: string): Promise<GoogleClaimReview[]> => {
  const { data } =  await api.get<GoogleClaimReview[]>(`/google-claims?query=${query}&lang=${language}`)
  return data;
}